import React from 'react'
import styles from './UIGameCardAnimator.module.scss'
import {useUIGameCardAnimatorContext} from './UIGameCardAnimatorContext'
import {UIGameCardAnimatorItem} from './UIGameCardAnimatorItem'

export const UIGameCardAnimator = () => {
    const {cards} = useUIGameCardAnimatorContext()

    return (
        <div className={styles.container}>
            {cards.map((card) => (
                <UIGameCardAnimatorItem key={card.id} {...card} />
            ))}
        </div>
    )
}
